import { DataGrid } from "@mui/x-data-grid";
import React, { useEffect, useState } from "react";
import "./DataExplorer.css";
import { getCostsOfAllTicketsByAssetId } from "src/apis/tickets";
import DataExplorerFilterComponent from "src/components/DataExplorer/DataExplorerFilterComponentV2";
import { filterButtons } from "src/util/dataExplorer_enums";
import {
  DataExplorerAssetColumns,
  DataExplorerAlarmColumns,
  DataExplorerTicketColumns,
} from "src/components/DataGrid/DataGridColumns";
import { fetchTicketStatus,fetchAlarmsWithFilter } from "src/apis/tickets";
import { filterAssets } from "src/apis/complex";
const DataExplorer = () => {
  const [tableRows, setTableRows] = useState([]);
  const [tableColumns, setTableColumns] = useState([]);
  const [selectedButton, setSelectedButton] = useState("Tickets");
  const [filterBody,setFilterBody]=useState(null);
  useEffect(()=>{
    console.log(selectedButton)
  },[filterBody,selectedButton])
  // changing the DataGrid row and column data based on the selected button
 const setFilterBodyWrapper=(siteId,buildingId,startDate,endDate,alarmImpact,assetType,assetSn, isOnerous,ticketStatus)=>{
  if (selectedButton === "Assets"){
    setFilterBody({
      "assetTypeId": assetType,
      "buildingId": buildingId,
      "siteId": siteId
    })
  }
  if (selectedButton === "Alarms") {
    setFilterBody({
    //  "assetId": 0,
      "buildingId": buildingId,
      "endDateStr": endDate,
      "impactId": alarmImpact,
      "siteId": siteId,
      "startDateStr": startDate,
     // "ticketStatusId": 0
    })

  }
  if (selectedButton === "Tickets") {
setFilterBody({
  "assetSn": assetSn,
  "buildingId": buildingId,
  "endDateStr": endDate,
  "isOnerous": isOnerous,
  "organizationId": 1,
  "siteId": siteId,
  "startDateStr": startDate,
  "statusId": ticketStatus,
})
  }
 }

  const loadTickets = async (filterQuery) => {
    {/**initialize filter Query */}
    if(!filterQuery){
      if (selectedButton === "Assets") {
        filterQuery={"siteId":1}
      }
      else{
      filterQuery={};}
    }
    if (selectedButton === "Assets") {
    //const response= null 
      const response=  await filterAssets(filterQuery)
      setTableRows(mapAssetRows(response));
      setTableColumns(DataExplorerAssetColumns);
    } 
    else if (selectedButton === "Alarms") {
      //const response = null 
      const response = await fetchAlarmsWithFilter(filterQuery);
      setTableRows(mapAlarmRows(response));
      setTableColumns(DataExplorerAlarmColumns);
    }
     else if (selectedButton === "Tickets") {
      //const response = null
      const response =await fetchTicketStatus(filterQuery);
      setTableRows(mapTicketRows(response));
      setTableColumns(DataExplorerTicketColumns);
    }
  };
 
  // table rows when the filter button changes to assets
  const mapAssetRows = (data) => {
   let id=0
   if(data && data.length>0){
    return data.map((item) => ({
      id: id++,
      site: item.siteName,
      asset: item.assetName,
      numberOfTickets: item.numTicket,
      timeSpentToSolve: item.timeSpentToSolve,
      cost: item.spent,
      budget:item.budgetAmount
    }));}
    else return null;
    
  };

  // table rows when the filter button changes to tasks
  const mapAlarmRows = (data) => {
    if(data && data.length>0){
      let id=0;
    return data.map((item) => ({
      id: id++,//item.itemSn,
      site: item.siteNameAssociated,
      building:item.buildingNameAssociated,
      asset: item.assetSnAssociated,
      date:item.date,
      severity:item.impactName,
      ticketStatus: item.ticketStatus,
      operator:item.operator,
    }));}
    else return null
  };
  const mapTicketRows = (data) => {
    if (data && data.length>0){
      let id =0;
    return data.map((ticket) => ({
      // id: ticket.id,
      id : id++,
      site: ticket.siteNameAssociated,
      building:ticket.buildingNameAssociated,
      asset: ticket.assetSnAssociated,
    severity: ticket.actualImpactType,
      ticketStatus:ticket.actualStatus,
      cost:ticket.feeAmountProposal
    }));}
    else return null;
  };

  const handleButtonClick = (id) => {
    setSelectedButton(id);
  };

  // changing row data when the filter button changes
  useEffect(() => {
    loadTickets();
  }, [selectedButton]);
  useEffect(() => {
  loadTickets(filterBody)
  }, [filterBody]); 
  
  return (
    <div className="dataExplorer">
      <h1>Data Explorer</h1>
      <div style={{ display: "flex", gap: "15px" }}>
        <DataExplorerFilterComponent filterType={selectedButton}  setFilters={setFilterBodyWrapper} />
        <div
          style={{
            flex: 1,
            display: "flex",
            flexDirection: "column",
            gap: "20px",
            marginBottom: "10px",
          }}
        >
          
          {/* Buttons on top of the grid */}
          <div style={{ display: "flex" }}>
            {filterButtons.map((button) => (
              <button
                style={{
                  flex: 1,
                  width: "100%",
                  height: "40px",
                  fontWeight: "bold",
                  cursor: "pointer",
                  backgroundColor:
                    selectedButton === button.name ? "#4B96EE" : "#282B30",
                  border:
                    selectedButton === button.name
                      ? "none"
                      : "0.5px solid gray",
                  color: selectedButton === button.name ? "white" : "gray",
                }}
                onClick={() => handleButtonClick(button.name)}
              >
                {button.name}
              </button>
            ))}
          </div>

          {/* Data grid to display results of selected button */}
          
          <div style={{ flex: 1 }}>
          {tableRows ? (
            <DataGrid
              style={{
                color: "white",
                backgroundColor: "#282b30",
                overflow: "hidden",
                border: "none",
              }}
              rows={tableRows}
              columns={tableColumns}
              initialState={{
                pagination: { paginationModel: { pageSize: 10 } },
              }}
              pageSizeOptions={0}
              sx={{
                ".MuiSvgIcon-root": {
                  fill: "white !important",
                },
                ".MuiDataGrid-selectedRowCount": {
                  color: "#282b30",
                },
                ".css-axafay-MuiDataGrid-virtualScroller": {
                  maxHeight: "435px !important",
                },
              }}
            />) : <p> No data available </p>}
          </div>
        </div>
      </div>
    </div>
  );
};

export default DataExplorer;
